var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contnet-titleback",style:({ width: _vm.width })},[_c('img',{staticClass:"top-titleview-leftimg",attrs:{"src":_vm.iconSrc,"alt":""}}),_c('div',{staticClass:"titleback-rightStr"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }